//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BlogCard from '~/components/blog-card.vue';
export default {
  components: {
    BlogCard,
  },
  async asyncData({ $content }) {
    const items = await $content('pitches').fetch();
    return {
      items,
    };
  },
  data() {
    return {
      heading: 'Pitches',
      description: "Damien Robinson's pitches",
      total: 0,
      items: [],
    };
  },
  head() {
    return {
      title: this.heading,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.heading },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },
      ],
    };
  },
};
